import { useRef, useState } from "react";

const useCalculator = () => {
  const [isOpen, setIsOpen] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const onLoad = () => {
    // Note: Cannot access iframe content due to CORS (Cross-Origin Resource Sharing) policy
    // The calculator is from a different domain (ti84calc.com) 
    // Browser security prevents accessing contentDocument from external domains
    console.log('Calculator iframe loaded - CORS prevents content manipulation');
  };

  return {
    isOpen,
    setIsOpen,
    iframeRef,
    onLoad,
  };
};

export default useCalculator;
